const LOGIN_REDIRECT_KEY = "login-redirect";
export const getStorageLoginRedirect = (): string | null =>
  sessionStorage.getItem(LOGIN_REDIRECT_KEY);

export const updateStorageLoginRedirect = (redirect: string): void => {
  sessionStorage.setItem(LOGIN_REDIRECT_KEY, redirect || "");
};
